import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { push } from "connected-react-router";
import {
  getDataComponent,
  getDataComponentFlattenedRequestState,
} from "../../../../reducers/dataComponentReducer";
import {
  getResourcesV2,
  getBluechipResourceById,
} from "../../../../utils/bluechipUtils";
import PurchaseOrder from "../../../../models/PurchaseOrder";
import { getRootFilters } from "./gridProps";
import PurchaseOrderPage from "./PurchaseOrderPage";
import {
  initRFQListFilter,
  rfqFilterDataComponent,
} from "../../../../actions/projectsActions";
import {
  showSnackNotificationAction,
  setAutoSaveComponentId,
  openModalDialog,
  closeModalDialog,
} from "../../../../actions/layoutActions";
import {
  performUpdateRequest,
  setReload,
} from "../../../../actions/dataComponentActions";
import {
  onUpdatePurchaseOrderStatus,
  processRequestsForPurchaseOrder,
} from "./PurchaseOrderFunctions";
import * as REQUEST_TYPES from "../../../../constants/RequestTypes";

export const dataComponentId = "PurchaseOrdersGrid";

export class PurchaseOrderContainer extends Component {
  componentDidMount() {
    const {
      match: { params },
      setAutoSaveComponentId,
      initRFQListFilter,
    } = this.props;
    setAutoSaveComponentId(dataComponentId);
    initRFQListFilter(params.projectId);
  }
  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const {
      dataComponent,
      setReload,
      showSnackNotificationAction,
    } = this.props;

    processRequestsForPurchaseOrder(
      prevDataComponent,
      dataComponent,
      dataComponentId,
      {
        setReload,
        showSnackNotificationAction,
        snackMessage: "Purchase Order issue successfully canceled.",
      }
    );
  }
  handleDownloadPO = ({ id }, type) => {
    const { openModalDialog } = this.props;
    openModalDialog(
      "Download PO PDF",
      "DownloadPurchaseOrderPDF",
      {
        format: type,
        purchaseOrderId: id,
        templateName: "purchase-order-detail",
      },
      true,
      true
    );
  };
  handleCancelIssue = purchaseOrder => {
    const {
      openModalDialog,
      closeModalDialog,
      performUpdateRequest,
    } = this.props;
    openModalDialog(
      "Cancel Purchase Order Issue",
      "CancelIssueDialog",
      {
        purchaseOrderId: purchaseOrder.id,
        onSubmit: () => {
          const params = {
            revert_last_status: "Pending Approval",
            revert_from_revision: purchaseOrder.currentRevisionId,
          };

          performUpdateRequest(dataComponentId, purchaseOrder.id, {}, params);
          closeModalDialog();
        },
      },
      false,
      true
    );
  };
  handleUpdatePurchaseOrderStatus = (
    purchaseOrder,
    status,
    dataComponentId,
    performUpdateRequest
  ) => {
    onUpdatePurchaseOrderStatus(
      purchaseOrder,
      status,
      dataComponentId,
      performUpdateRequest
    );
  };
  render() {
    const {
      match: { params },
      purchaseOrderDataComponent,
      push,
      rfqs,
      project,
      location,
    } = this.props;

    return (
      <PurchaseOrderPage
        dataComponent={purchaseOrderDataComponent}
        apiFilters={{
          rootFilters: getRootFilters(params.projectId),
          params: {
            omitDefaultModifier: true,
            purchaseOrdersExpeditingView: true,
          },
        }}
        defaultSorting={[{ columnName: "number", direction: "asc" }]}
        onDownloadPO={this.handleDownloadPO}
        onCancelPurchaseOrder={this.handleCancelIssue}
        model={PurchaseOrder}
        includes={[
          "vendor",
          "bidGroup",
          "shipAddress.location",
          "shipVendorAddress.[vendor.location, location]",
        ]}
        apiRoute="purchase-orders"
        projectId={params.projectId}
        clientId={params.clientId}
        push={push}
        rfqs={rfqs}
        project={project}
        locationSearch={location?.search}
      />
    );
  }
}

PurchaseOrderContainer.propTypes = {
  dataComponent: PropTypes.object.isRequired,
  purchaseOrderDataComponent: PropTypes.object.isRequired,
  openModalDialog: PropTypes.func.isRequired,
  setAutoSaveComponentId: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  performUpdateRequest: PropTypes.func.isRequired,
  initRFQListFilter: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  push: PropTypes.func,
  rfqs: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  project: PropTypes.object,
  closeModalDialog: PropTypes.func,
  location: PropTypes.object,
};

export const mapStateToProps = (state, ownProps) => {
  const rfqsDataComponent = getDataComponent(rfqFilterDataComponent, state);
  const projectId = ownProps.match.params.projectId;

  const projectDataComponent = getDataComponentFlattenedRequestState(
    "ProjectDetail",
    state,
    REQUEST_TYPES.FIND
  );
  const project = getBluechipResourceById(
    projectDataComponent,
    state,
    projectId
  );

  return {
    dataComponent: getDataComponent(dataComponentId, state),
    purchaseOrderDataComponent: getDataComponentFlattenedRequestState(
      dataComponentId,
      state
    ),
    rfqs: getResourcesV2(rfqsDataComponent, state, REQUEST_TYPES.LIST, []),
    project,
  };
};

const mapDispatchToProps = {
  push,
  openModalDialog,
  closeModalDialog,
  setAutoSaveComponentId,
  performUpdateRequest,
  setReload,
  showSnackNotificationAction,
  initRFQListFilter,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderContainer)
);
